import Sidebar from "../sections/sidebar";
import "../../styles/scaffold/scaffold.css";
import Client from "../../Client";

export function MainWindow({ currentTab, className, subtab, children }) {
    return (
        <div className={"scaffold" + (className ? " " + className : "")}>
            {Client.environment === "dev" ? <div className="umbrella">YOU ARE CURRENTLY ON <b>TESTING MODE</b></div> : ""}
            <div className="window">
                <Sidebar currentTab={currentTab} subtab={subtab} />
                <main>{children}</main>
            </div>
            <aside className="modals"></aside>
        </div>
        
    );
}
